// The category master supplies dcc_id/dcc; AddDriver persists dcc text as firm_types.
// Do not infer category from free-text designation or invent numeric category IDs.
export const staffCategory = row => ({ driver: "Driver", conductor: "Conductor", attendant: "Attendant" }[String(row.firm_types ?? "").trim().toLowerCase()] || "Unknown");
// API/Reports/school rows carry school_id, not users_id. A school is a users_mst account and
// personnel/bus records store that account's users_id as school_id, so school_id is the users_id.
export const schoolUsersId = school => {
  const id = school?.users_id ?? school?.school_id;
  return id == null || String(id).trim() === "" ? null : String(id);
};
// The school id travels in the URL so School Details can reload after a page refresh.
export const schoolViewPath = school => {
  const id = schoolUsersId(school);
  return id ? `/school/view?school_id=${encodeURIComponent(id)}` : "/school/view";
};
// IDs arrive base64-encoded from some endpoints and plain from others.
const decode = id => { try { return atob(id); } catch { return null; } };
export const sameId = (a, b) => {
  const x = String(a).trim(), y = String(b).trim();
  return x === y || decode(x) === y || x === decode(y);
};
export function schoolStaff(rows, school) {
  const seen = new Set();
  return rows.filter(row => {
    const matches = row.school_id != null && school.school_id != null
      ? sameId(row.school_id, school.school_id)
      : Boolean(school.school && (row.school === school.school || row.firm_name === school.school));
    if (!matches) return false;
    // Registration and names are not unique identities.
    if (row.driver_id == null) return true;
    const key = String(row.driver_id);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
export function reconcileStaff(rows, summary) {
  const breakdown = ["Driver", "Conductor", "Attendant", "Unknown"].map(category => {
    const records = rows.filter(row => staffCategory(row) === category);
    const counts = { category, total: records.length, pending: 0, approved: 0, rejected: 0, other: 0 };
    records.forEach(row => {
      const status = String(row.police_station_level1_status ?? "").trim().toLowerCase();
      counts[["pending", "approved", "rejected"].includes(status) ? status : "other"]++;
    });
    return counts;
  });
  const totals = breakdown.reduce((out, row) => {
    ["total", "pending", "approved", "rejected", "other"].forEach(key => { out[key] += row[key]; });
    return out;
  }, { total: 0, pending: 0, approved: 0, rejected: 0, other: 0 });
  const mismatch = [["total", "total"], ["pending", "pending"], ["approve", "approved"], ["reject", "rejected"]].some(([api, loaded]) => summary[api] != null && String(summary[api]).trim() !== "" && Number(summary[api]) !== totals[loaded]);
  return { breakdown, totals, warning: mismatch || totals.other || breakdown[3].total
    ? "Reconciliation requires review: API summary and loaded police-status totals differ, or unclassified records/statuses exist. Summary counting rules and API completeness must be verified; reported counts have been retained."
    : "" };
}
